import { FlexBox } from '@airship-platform/jam-web/components';
import {
  BarChartIcon,
  ClockIcon,
  CollectionIcon,
  DollarSignIcon,
  MapIcon,
  SmileIcon,
} from '@airship-platform/jam-web/icons';
import Typography from '@mui/material/Typography';

type SignUpCardContent = Record<
  'businessOwners' | 'technicians',
  {
    title: string;
    items: { icon: React.ElementType; text: string }[];
  }
>;

const signUpCardContent: SignUpCardContent = {
  businessOwners: {
    title: 'For Business Owners and Sales Managers',
    items: [
      {
        icon: CollectionIcon,
        text: 'Standardizes how your technicians sell in the field.',
      },
      {
        icon: MapIcon,
        text: 'Turns best practices from your top performers into a guide for your low performers.',
      },
      {
        icon: BarChartIcon,
        text: 'Increases business performance, sales efficiency, and transparency.',
      },
    ],
  },
  technicians: {
    title: 'For Technicians and Comfort Advisors',
    items: [
      {
        icon: ClockIcon,
        text: 'Reduces the time and effort to create proposals on the spot.',
      },
      {
        icon: SmileIcon,
        text: 'Builds greater trust with customers through beautiful proposal presentations.',
      },
      {
        icon: DollarSignIcon,
        text: 'Increases replacement ticket sizes by 20% or more.',
      },
    ],
  },
};

const SignUpCard: React.FC = () => (
  <FlexBox
    width={'100%'}
    height={'100%'}
    alignItems={'center'}
    flexDirection={'column'}
    justifyContent={'center'}
  >
    <FlexBox flexDirection={'column'} maxWidth={'40rem'}>
      <Typography variant={'h2'} gutterBottom>
        Make more on every call with Airship
      </Typography>
      <FlexBox marginTop={'2rem'} gap={4}>
        {Object.values(signUpCardContent).map((column, index) => (
          <FlexBox key={index} gap={3} flexDirection={'column'}>
            <Typography variant="h4" color={'primary'} gutterBottom>
              {column.title}
            </Typography>
            {column.items.map((item) => (
              <Typography
                key={item.text}
                component={'div'}
                variant={'body2'}
                sx={{ display: 'flex', gap: 1 }}
              >
                <FlexBox
                  height={'1.5rem'}
                  width={'1.5rem'}
                  color={(theme) => theme.palette.primary.main}
                >
                  <item.icon color="primary" width={24} />
                </FlexBox>
                {item.text}
              </Typography>
            ))}
          </FlexBox>
        ))}
      </FlexBox>
    </FlexBox>
  </FlexBox>
);

export default SignUpCard;
